module.exports = __webpack_public_path__ + "img/task-normal.e423313d.svg";